import {sorting} from "@atttomyx/shared-utils";

export const sortByStart = (a, b) => {
    return sorting.sortByField(a, b, "start");
};

export const sortByStartAndStop = (a, b) => {
    return sorting.sortByFields(a, b, "start", "stop");
};
